import React from 'react';
import Countdown from 'react-countdown';
import { useTranslation } from 'react-i18next';
import { CaptionText, H2, P2 } from '../../../styles/FontStyles';
import styled from 'styled-components';

export const CountdownNumbers = styled.div`
  display: flex;
  align-items: center;
  > div {
    width: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;

    div {
      color: #d0504d;
    }
  }
  img {
    width: 100%;
  }
`;

export const Counter = ({ timestamp }: any) => {
  return (
    <Countdown
      date={timestamp}
      renderer={({ days, hours, minutes }) => (
        <CountdownNumbers>
          <div>
            <P2 bold>{days}:</P2>
          </div>
          <div>
            <P2 bold>{hours}:</P2>
          </div>
          <div>
            <P2 bold>{minutes}</P2>
          </div>
        </CountdownNumbers>
      )}
    />
  );
};
